export default "__VITE_ASSET__3f9d07b5__"